import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid grid-cols-[repeat(7,minmax(0,159px))] gap-2" }
const _hoisted_2 = { class: "font-semibold text-xl leading-[24px] text-brown" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "absolute w-[52px] h-6 bg-error-dark rounded-tr-xl rounded-bl-xl top-0 right-0 text-center"
}
const _hoisted_5 = { class: "text-white text-xs" }
const _hoisted_6 = { class: "text-left whitespace-nowrap" }
const _hoisted_7 = { class: "text-left whitespace-nowrap" }
const _hoisted_8 = { class: "flex flex-col gap-1 h-full" }
const _hoisted_9 = { class: "size-5 bg-yellow-300 rounded-full text-xs text-brown flex items-center justify-center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-brown font-medium text-base lg:text-[40px] lg:leading-100p" }
const _hoisted_12 = { class: "text-muted text-sm max-lg:leading-[24px]" }
const _hoisted_13 = { class: "border border-muted rounded-lg p-2" }
const _hoisted_14 = { class: "font-bold text-xs break-all" }
const _hoisted_15 = { class: "border border-success rounded-lg px-2 py-1" }
const _hoisted_16 = { class: "font-normal text-xs text-brown break-all" }
const _hoisted_17 = {
  key: 1,
  class: "green-container"
}
const _hoisted_18 = {
  key: 2,
  class: "green-container"
}
const _hoisted_19 = { class: "text-sm text-brown text-left" }
const _hoisted_20 = { class: "border border-error-dark rounded-lg px-2 py-1" }
const _hoisted_21 = { class: "font-normal text-xs text-brown max-xl:break-all" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = {
  key: 0,
  class: "red-container"
}
const _hoisted_24 = {
  key: 1,
  class: "font-normal text-xs text-brown"
}
const _hoisted_25 = {
  key: 1,
  class: "red-container"
}
const _hoisted_26 = { class: "text-sm text-brown text-left" }
const _hoisted_27 = { class: "text-muted text-xs" }

import { computed } from "vue";
import {
  ChineseCalendarAction,
  ChineseCalendarDate,
} from "@/types/calculators";
import { useI18n } from "vue-i18n";
import { WEEK_KEYS } from "@/constants/chineseCalendar";
import ChineseIcon from "@/views/Calculators/ChineseCalendar/components/ChineseIcon.vue";
import AppTooltip from "@/components/AppTooltip.vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import retrogradeIcon from "@/assets/icons/chineseCalendar/retrograde.svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'DescktopCalendar',
  props: {
    chineseCalendar: {},
    month: {},
    year: {},
    monthKey: {},
    showAsIcons: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const firstDay = computed(() => {
  const startOfMonth = new Date(props.year, props.month, 1);
  const firstDayIndex = startOfMonth.getDay() - 1;
  // Sunday has 0 index that after -1 gives -1 index
  if (firstDayIndex == -1) {
    return 6;
  }
  return firstDayIndex;
});

const lastDay = computed(() => {
  const lastDay = new Date(props.year, props.month + 1, 0);
  return 7 - lastDay.getDay();
});

function openFullDayInfo(date: string) {
  router.push({
    name: ROUTE_NAMES.CHINESE_CALENDAR_DAY,
    query: { date: date },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEEK_KEYS), (weekKey) => {
      return (_openBlock(), _createElementBlock("div", {
        key: weekKey,
        class: "h-10 max-w-40 flex items-center justify-center bg-white rounded-lg"
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(`week-names.${weekKey}`)), 1)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstDay.value, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: "bg-[#E3E3E3] rounded-lg"
      }))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.chineseCalendar, (chineseDay, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: chineseDay.date,
        class: "flex flex-col overflow-visible bg-white rounded-lg gap-4 px-2 pt-2 pb-4 text-left relative cursor-pointer",
        onClick: ($event: any) => (openFullDayInfo(chineseDay.date))
      }, [
        (chineseDay.season.new !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(AppTooltip, null, {
                trigger: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(chineseDay.season.change_time), 1)
                ]),
                popper: _withCtx(() => [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("calculators.chinese-calendar.season.end-tooltip", {
                  season: chineseDay.season.current,
                  time: chineseDay.season.change_time,
                })), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("calculators.chinese-calendar.season.start-tooltip", {
                  season: chineseDay.season.new,
                })), 1)
                ]),
                _: 2
              }, 1024)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex lg:items-end gap-1", { 'mt-6 lg:mt-0': chineseDay.season.new !== undefined }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(AppTooltip, null, {
              trigger: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(chineseDay.moon_day), 1)
              ]),
              popper: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.moon-day", {
                  moon_day: chineseDay.moon_day,
                })), 1)
              ]),
              _: 2
            }, 1024),
            (chineseDay.is_retrograde)
              ? (_openBlock(), _createBlock(AppTooltip, { key: 0 }, {
                  trigger: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _unref(retrogradeIcon),
                      alt: "retrograde day",
                      class: "size-4 mx-auto"
                    }, null, 8, _hoisted_10)
                  ]),
                  popper: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)(
                  "calculators.chinese-calendar-day.day-summary.retrograde.content"
                )), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_11, _toDisplayString(index + 1), 1),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)(`months.${__props.monthKey}`)), 1)
        ], 2),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(chineseDay.officer), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("calculators.chinese-calendar.day-of", {
              animal: chineseDay.conform,
            })), 1)
        ]),
        (__props.showAsIcons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chineseDay.actions.filter((a) => a.is_positive), (action) => {
                return (_openBlock(), _createBlock(ChineseIcon, {
                  name: action.doing,
                  key: action.doing
                }, null, 8, ["name"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("p", _hoisted_19, _toDisplayString(chineseDay.actions
              .filter((a) => a.is_positive)
              .map((a) =>
                _unref(t)(`calculators.chinese-calendar.doing.${a.doing}`)
              )
              .join(", ")), 1)
            ])),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)("calculators.chinese-calendar.no-conform", {
              animal: chineseDay.no_conform,
            })), 1)
        ]),
        (chineseDay.actions.filter((a) => !a.is_positive).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (__props.showAsIcons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chineseDay.actions.filter((a) => !a.is_positive), (action) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: action.doing
                      }, [
                        (action.doing !== 'not_suitable_for_important_matters')
                          ? (_openBlock(), _createBlock(ChineseIcon, {
                              key: 0,
                              name: action.doing
                            }, null, 8, ["name"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(t)(
                  "calculators.chinese-calendar.doing.not_suitable_for_important_matters"
                )), 1))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("p", _hoisted_26, _toDisplayString(chineseDay.actions
                .filter((a) => !a.is_positive)
                .map((a) =>
                  _unref(t)(`calculators.chinese-calendar.doing.${a.doing}`)
                )
                .join(", ")), 1)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_27, _toDisplayString(chineseDay.season.new !== undefined
            ? _unref(t)("calculators.chinese-calendar.change-season")
            : chineseDay.season.current), 1)
      ], 8, _hoisted_3))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lastDay.value, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: "bg-[#E3E3E3] rounded-lg"
      }))
    }), 128))
  ]))
}
}

})